import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';
import 'firebase/compat/firestore';
import { GlobalContext } from '../../context/GlobalState';
import { useContext, useState } from 'react';
import { render } from '@testing-library/react';

const firebaseConfig = {
    apiKey: "AIzaSyDqlmodqis4a4gsYIA5tIw6Kv2x7vVS7Y4",
    authDomain: "boovieplex-ccc62.firebaseapp.com",
    projectId: "boovieplex-ccc62",
    storageBucket: "boovieplex-ccc62.appspot.com",
    messagingSenderId: "435096821724",
    appId: "1:435096821724:web:133724485a107704dab919",
    measurementId: "G-MJ7KTZ2S2W"
    };

const app = firebase.initializeApp(firebaseConfig);
const auth = app.auth();
const db = app.firestore();
let user;



  function Login() {

      const googleProvider = new firebase.auth.GoogleAuthProvider();

      const signInWithGoogle = async () => {
      try {
        const res = await auth.signInWithPopup(googleProvider);
        user = res.user;
        const query = await db
          .collection("users")
          .where("uid", "==", user.uid)
          .get();
        if (query.docs.length === 0) {
          await db.collection("users").add({
            uid: user.uid,
            name: user.displayName,
            authProvider: "google",
            email: user.email,
          });
        }
        console.log(`Logged in as ${user.displayName}`);
        setIsSignedIn(true);
      } catch (err) {
        console.error(err);
        alert(err.message);
        setIsSignedIn(false);
      }
    };

    const logOut = () => {
      auth.signOut();
      setIsSignedIn(false);
    };

    const [isSignedIn, setIsSignedIn] = useState(false);
    return(
      <div className="signInContainer">
        {isSignedIn ? (
          <div style={{display: 'flex'}}>
            <p style={{fontSize: '12px'}}>{user.displayName}</p>
            <button className="btn-warning" id="logoutBtn" style={{ fontSize: '15px', width: '10rem' }} onClick={() => logOut()}>Log Out</button>
          </div>
        ) : (
          <button className="btn-warning" id="loginBtn" style={{ fontSize: '15px', width: '8rem', marginBottom: '1.2rem'}} onClick={() => signInWithGoogle()}>Log In</button>
        )}
      </div>
    )
  }

  export default Login;